module.exports = __webpack_public_path__ + "static/media/icon_swap.b5940d58.png";